module.exports = "<v-layout justify-space-between class=\"pl-1 agenda-sidebar\">\n  <v-flex xs12 sm6 class=\"my-3\">\n    <v-date-picker v-model=\"dtDate\" @input=\"handleDateChange\" width=\"250\" :locale=\"coLocale\" class=\"date-picket-transparent\" :no-title=\"true\"\n      :events=\"eventDotsDate\"></v-date-picker>\n  </v-flex>\n</v-layout>";


//////////////////
// WEBPACK FOOTER
// ./src/containers/agenda/components/agenda-sidebar-date-picker/template.html
// module id = /09v
// module chunks = 0